import * as types from '../constants/commonConstants';
import { IS_ENABLE_RSA } from './../constants/index';

const initialState = {
  loading: false,
  loaded: false,
  user: {
    name: null,
    authToken: null,
    status: 'failure',
    detailedInstList : false,
  },
  accBal:null,
  ShowTC:false,
  showRP:false,
  logoutSuccess:true,
  forcedLogin:false,
  loaderFlag:false,
  loginSuccFlag:false,
  errorMsg:"",
  showMidInCompany:false,
  isFwdEnableForBMK:false,
};

export default function(state = initialState, action)  {
  switch (action.type) {
    case 'LOADING_ON':
      return {
        ...state,
        loading: true,
      };
    case 'LOADING_OFF':
      return {
        ...state,
        loading: false,
      };
    case 'SUCCESS_DEFAULT':
      return {
        ...state,
      };
    case 'FAILURE_DEFAULT':
      return {
        ...state,
      };
    case 'LOAD':
      return {
        ...state,
      };
    case 'LOAD_SUCCESS':
      return {
        ...state,
        loaded: true,
        user: action.result
      };
    case 'LOAD_FAILURE':
      return {
        ...state,
        loaded: false,
        error: action.error
      };
    case 'LOGIN':
      return {
        ...state,
        loggingIn: true,
        loaderFlag:true,
        loginSuccFlag:false
      };
    case 'LOGIN_SUCCESS':
		  localStorage.setItem('ver', Math.random());
      localStorage.setItem('backButtonFlag','false');
      localStorage.setItem('logoutClose','false');
      localStorage.setItem('windowForcedLogin','false');
      localStorage.setItem("MsgSqNo",0);
      localStorage.setItem('trdCTID',null);
      const userObj = action.result.userObj;
      localStorage.setItem('trdCode',userObj.traderCode);
      //VAPT task: Encryption of user details in login action
      let tempResponse= IS_ENABLE_RSA ?action.response : JSON.parse(action.response);
      const user={location : tempResponse.location, id : userObj.UID, sid : userObj.SID,'authToken': action.result.data.authToken};
	     localStorage.removeItem('user');
      localStorage.setItem('user', JSON.stringify(user));
      const msg = action.result.message;
      localStorage.setItem('RP',userObj.RP);
      localStorage.setItem('location',tempResponse.location);
      userObj.ACD.map(item =>{
          if(item.DFA==="1"){
            var obj={'AC':item.C,'AD':item.D};
            localStorage.setItem('DefaultAC',JSON.stringify(obj));
          }
        })
      localStorage.setItem('user',JSON.stringify(user));
      localStorage.setItem('TRD_STATUS',userObj.canTrade);
      let traderAccounts = userObj.ACD.map(item => item.C );
      localStorage.setItem('traderAccounts', JSON.stringify(traderAccounts));
      if(userObj.RP!==true){
		  localStorage.removeItem('userlogin');
          localStorage.setItem('userlogin', 'true');
      }
      const errorMsg = errorMessage(msg);
      var temp=[""];
      var obj={'array':temp};
      localStorage.setItem('trdPnlCmdty',JSON.stringify(obj));
      localStorage.setItem('isFwdEnableForBMK',userObj.isFwdEnableForBMK);
      var LLD;
      if(userObj.LLD === null || userObj.LLD ==="" || userObj.LLD === "null"){
        LLD="";
      }
      else{
        LLD=userObj.LLD;
      }
      return {
        ...state,
        loaded: true,
        loggingIn: false,
        user: { ...action.result.data, name: userObj.traderCode,LLD:LLD, location : tempResponse.location, id : userObj.UID, sid : userObj.SID },
        message: action.result.message,
        errorMsg:errorMsg,
        accBal:action.result.accBalance,
        TS: userObj,
        forcedLogin:false,
		    logoutSuccess: false,
        showRP:userObj.RP,
        ShowTC:!userObj.isTcAcpt,
        loaderFlag:true,
        loginSuccFlag:true,
        showMidInCompany:userObj.showMidInCompany,
        isFwdEnableForBMK:userObj.isFwdEnableForBMK 
      };
      case 'LOGIN_FAILURE':
      if(action.result === undefined){
          return{
              ...state,
            forcedLogin:false,
            loaded: false,
            loggingIn: false,
            loaderFlag:false,
            loginSuccFlag:false
         };
      }
      else {
        if(action.result.message==="203"){
            return{
              ...state,
              forcedLogin:true,
              forceUser:action.result.accBalance.user,
              forcepwd:action.result.accBalance.pwd,
              message: action.result.message,
              loaded: false,
              loggingIn: false,
              errorMsg:errorMessage(action.result.message),
              error: action.result ? action.result.data : '',
              loaderFlag:false,
              loginSuccFlag:false
            };
        }else {
        return {
              ...state,
              forcedLogin:false,
              message: action.result.message,
              loaded: false,
              loggingIn: false,
              errorMsg:errorMessage(action.result.message),
              error: action.result ? action.result.data : '',
              loaderFlag:false,
              loginSuccFlag:false
            };
        }
      }

    // Uncomment if there is logout api
    case 'LOGOUT':
      return {
        ...state,
      };
    case 'LOGOUT_SUCCESS':
    	localStorage.setItem('user', null);
      localStorage.setItem('userAuthToken', null);
      localStorage.setItem('userlogin', null);
      localStorage.setItem('cmdtyArray', JSON.stringify([]));
      //localStorage.setItem('backButtonFlag','false');
        return {
        ...state,
        user: null,
        message: action.result.message,
        logoutSuccess: true,
        showRP:false,
        loaderFlag:false,
        loginSuccFlag:false
      };
    case 'KILL_LOGOUT':
      localStorage.setItem('user', null);
      localStorage.setItem('userAuthToken', null);
      return {
      ...state,
      user: null,
      logoutSuccess: true,
      loaderFlag:false,
      loginSuccFlag:false
    };
    // Uncomment if there is logout api
    case 'LOGOUT_FAILURE':
      return {
        ...state,
        logoutError: action.error,
      };
    case 'HANDLE_SESSION':
      return {
        ...state,
        logoutSuccess: true
      };

      case 'ACCEPT':
      return{
        ...state,
        ShowTC:true
      };

      case 'ACCEPT_SUCCESS':
      return{
        ...state,
        ShowTC:false,
        loginSuccFlag:false
      };

      case 'ACCEPT_FAILURE':
      return{
        ...state,
        ShowTC:true
      };

      case 'CHANGE':
      return{
          ...state,
          ShowTC:action.status
      };
    case  'LOAD_CHANGE_PASSWORD_SUCCESS':
	  return{
      ...state,
      showRP:action.data,
      user: null,
      message:action.error ? action.message : "Reset Password",
      logoutSuccess: true,
      loaderFlag:false,
      loginSuccFlag:false
    };
    case 'FORCED_LOGOUT_CLOSED':
      return{
        ...state,
        forcedLogin:false
      }
    case 'RESETPASS_FLAG':
     localStorage.setItem('userlogin', null);
    return{
      ...state,
      user:null,
      showRP:false,
      ShowTC:false,
    };
    case  'LOGIN_MESSAGE':
      return{
        ...state,
        errorMsg:"",
      };
      break;
    case 'RSET_LOGIN_LOADER_FLAG':
    return{
      ...state,
      loginSuccFlag:false
    }
    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}
/**
 * Actytion to fetch current user data.
 */
// export function load() {
//   return {
//     type: 'LOAD_SUCCESS',
//     result: {
//       status: 'failure',
//       authToken: null
//     }
//   };
// }
// export function changeLoaderLogin(){
//   return{
//     type: RSET_LOGIN_LOADER_FLAG,
//   };
// }
// export function changeState(flag){
//   return {
//     type:'CHANGE',
//     status:flag
//   };
// }

export function errorMessage(msg) {
let errorMsg;
switch (msg) {
    	case "201":
      errorMsg = "Invalid Trader Code or Password"
      break
      case "202":
      errorMsg = "Invalid Trader Code or Password"
      break
    	case "203":
    	errorMsg = "Another active session on same platform. Please contact your StoneX Trading Desk."
      break
    	case "204":
      errorMsg = "Invalid Password. Maximum login attempts reached. Password blocked. Please contact your StoneX Trading Desk."
      break
      case "205":
    	errorMsg = "Login blocked. Please contact your StoneX Trading Desk."
      break
      case "206":
      errorMsg = "Invalid Trader Terminal. Please contact your StoneX Trading Desk."
      break
      case "207":
      errorMsg = "Invalid Credentials."
      break
      case "208":
      errorMsg ="No Accounts Linked. Please contact your StoneX Trading Desk."
      break
      case "209":
      errorMsg ="Invalid Password. Your account will get locked, in case of incorrect password in the next attempt."
      break
      case "210":
      errorMsg ="Login Failed."
      break
      default:
      errorMsg = "Login Succesful"
      };
      return errorMsg;
  }
